/* eslint-disable @typescript-eslint/no-var-requires */
import { apiClient } from './apiClient';
import { Buffer } from './constants/generalConstants';
import { store } from './store/configureStore';
import { KahlActionTypes } from 'saga/kahl/ducks';

/*
 * TODO: refactor downloadUrl & downloadFile ??
 * TODO: refactor into saga?
 * downloadUrl
 */
export const downloadUrl = (url: string) => {
  if (!url) {
    return;
  }

  apiClient
    .get(url, {
      responseType: 'blob',
    })
    .then((res: any) => {
      if (res.ok) {
        const link = document.createElement('a');
        let contentDispositionString = 'Content-Disposition';

        if (!res.headers[contentDispositionString]) {
          contentDispositionString = 'content-disposition';
        }

        const [, filename] = res.headers[contentDispositionString].split('filename=');

        link.target = '_blank';
        link.download = removeDoubleQuotes(decodeURIComponent(filename));
        link.href = URL.createObjectURL(new Blob([res.data]));
        link.click();
        link.remove();
      } else {
        store?.dispatch({
          type: KahlActionTypes.GetKahlOutsideComponent,
          payload: {
            infoMessageIds: 'ID1594',
          },
        });
      }
    });
};

// downloadFile
export const decodeBase64 = (data: string) => {
  const { Buffer } = require('buffer');

  return new Buffer(data, 'base64');
};

export const removeDoubleQuotes = (filename: string): string => {
  return filename.replace(/^"+|"+$/g, '');
};

export const encodedBufferToUTF8 = (data: Buffer, encoding: string, prependBOM = false) => {
  // decode uint buffer to correct string depending on source encoding
  const decoded = new TextDecoder(encoding).decode(data);
  // encode back to utf8 & optionally add utf8 BOM because otherwise excel might not read data from csv files correctly
  const encoded = new TextEncoder().encode(prependBOM ? `\ufeff${decoded}` : decoded);

  return encoded.buffer;
};

export const downloadFile = (content: ArrayBuffer, filename: string, mediaType: string): void => {
  const blob = new Blob([content], { type: mediaType });
  const fileURL = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = fileURL;
  link.download = filename;
  link.click();
  link.remove();
};
